import { Dispatch, SetStateAction, useState } from 'react';
import * as yup from 'yup';
import { Package } from 'types/package';

export type PackageValidation = {
  name?: string;
  cost_price?: string;
  supplier_id?: string;
  sale_price_min?: string;
  sale_price_max?: string;
};

type UsePackageValidation = [
  PackageValidation,
  Dispatch<SetStateAction<PackageValidation>>,
  (pkg: Package) => Promise<void>,
];

export function usePackageValidation(): UsePackageValidation {
  async function handleValidation(pkg: Package) {
    const schema = yup.object().shape({
      sale_price_max: yup.string().required('O preço de venda máximo é obrigatório'),
      sale_price_min: yup.string().required('O preço de venda mínimo é obrigatório'),
      supplier_id: yup
        .string()
        .required('O fornecedor é obrigatório')
        .test(`is-positive`, 'Selecione um fornecedor', value => {
          if (!value) return false;
          return parseInt(value) > 0;
        }),
      cost_price: yup
        .string()
        .required('O custo é obrigatório')
        .test(`is-positive`, 'O custo deve ser maior que zero', value => {
          if (!value) return false;
          const number = Number(value.toString().replaceAll('.', '').replace(',', '.'));
          return number > 0;
        }),
      name: yup.string().required('O nome do pacote é obrigatório'),
    });

    try {
      await schema.validate(pkg);
    } catch (err) {
      const error = err as yup.ValidationError;
      if (error.path && error.message) {
        setValidation({
          [error.path]: error.message,
        });
      }
      throw new Error(err as string);
    }
  }

  const [validation, setValidation] = useState<PackageValidation>({});
  return [validation, setValidation, handleValidation];
}
